import {EventEmitter, Input, Output} from '@angular/core';
import {appInjector} from 'src/app/classes/appInjector';
import {GlobalEventsService} from 'src/app/services/global-events.service';

declare var Yiit;

export abstract class AbstractColorPicker {
  @Output()
  public selected: EventEmitter<string> = new EventEmitter<string>();

  public Yiit = Yiit;

  private _disabled = null;
  @Input()
  set disabled(val: any) {
    this._disabled = val ? 'disabled' : null;
  }

  get disabled(): any {
    return this._disabled;
  }

  private _selectedColor: string;

  @Input()
  set selectedColor(val: string) {
    if (!val) {
      return;
    }
    if (val.trim().charAt(0) !== '#') {
      val = this.tryGetColorHexFromString(val);
    }
    this._selectedColor = val;
  }

  get selectedColor(): string {
    return this._selectedColor;
  }

  change() {
    appInjector.get(GlobalEventsService)
      .ToastNotificationEvent.emit({
      message: 'Updating ...',
      autoHideDelay: 1500,
      title: 'Update color',
      classes: ['notification']
    });
    this.selected.emit(this.selectedColor);
  }

  protected tryGetColorHexFromString(val: string) {
    const tmpEl = document.createElement('div');
    tmpEl.style.color = val;
    document.body.appendChild(tmpEl);
    const computedColor = window.getComputedStyle(tmpEl).color;
    document.body.removeChild(tmpEl);
    return `#${computedColor
      .match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+\.{0,1}\d*))?\)$/)
      .slice(1)
      .map((n, i) => (i === 3 ? Math.round(parseFloat(n) * 255) : parseFloat(n))
        .toString(16).padStart(2, '0').replace('NaN', '')
      )
      .join('')}`;
  }
}
